/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Sharing_Connected_LabelInputs */

const es_privacy_policy_sharing_connected_label = /** @type {(inputs: Privacy_Policy_Sharing_Connected_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Servicios Conectados (con su autorizacion)`)
};

const en_privacy_policy_sharing_connected_label = /** @type {(inputs: Privacy_Policy_Sharing_Connected_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected Services (with your authorization)`)
};

/**
* | output |
* | --- |
* | "Connected Services (with your authorization)" |
*
* @param {Privacy_Policy_Sharing_Connected_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_sharing_connected_label = /** @type {((inputs?: Privacy_Policy_Sharing_Connected_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Sharing_Connected_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_sharing_connected_label(inputs)
	return en_privacy_policy_sharing_connected_label(inputs)
});
export { privacy_policy_sharing_connected_label as "privacy_policy.sharing.connected_label" }